<template>
    <DashView>
        <div class="container-fluid pt-4 px-4 pb-5 mb-5">
            <div class="row g-4">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <h3><a href="/patient-register"><i class="fa fa-plus-square"></i></a>&nbsp;Dossiers Déclassés<span class="badge bgbadge">{{ dossiers.length }}</span> </h3><br>
                            <div class="table-responsive">
                                <template v-if="dossiers.length>0">
                                    <div class="table-wrapper">
                                        <table class="table table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Numéro Dossier</th>
                                                <!-- <th>Patient</th> -->
                                                <th>Docteur</th>
                                                <th>Service</th>
                                                <th>Specialité</th>
                                                <th>Status</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(dossier,key) in dossiers" :key="key">
                                                <td><router-link :to="{ name: 'consultation-dossier', params: { dossier: dossier.code_dossier } }" title="Voir" @click="redirectTo(`/consultation-dossier/${dossier.code_dossier}`);">{{dossier.code_dossier}}</router-link></td>
                                                <!-- <td>{{dossier.nom_patient}} {{dossier.prenom_patient}}</td>                                            -->
                                                <td>{{dossier.nom_docteur}} {{dossier.prenom_docteur}}</td>                                           
                                                <td>{{dossier.service}}</td>                                               
                                                <td>{{dossier.specialite}}</td>
                                                <td>{{dossier.dossier_status === 1 ? 'Ouvert' : 'Fermé' }}</td>
                                                <td>
                                                    <a title="Interface consultation" @click="redirectTo(`/consultation-dossier/${dossier.code_dossier}`);"><i class="fa fa-eye"></i></a> &nbsp; &nbsp;
                                                    <!-- <button type="button" @click="getIdDeclasser(dossier.id_declasser)" title="Ajouter info préliminaire" data-bs-toggle="modal" data-bs-target="#preliminaire-consul" class="btn"><i class="fa fa-plus"></i></button> -->
                                                    <!-- <router-link :to="{ name: 'consultation-dossier', params: { dossier: dossier.code_dossier } }" title="Voir" @click="redirectTo(`/consultation-dossier/${dossier.code_dossier}`);"><i class="fa fa-eye"></i></router-link> -->
                                                    <!-- <a href="#" class="text-inverse pr-2"  title="Voir"><i class="fa fa-eye"></i></a> -->
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    </div>                                    
                                </template>
                                <template v-else>
                                    <div class="modal-preloader">
                                        <span>Aucune donnée à afficher</span>
                                        <!-- <div class="spinner"></div> -->
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </DashView>
    <!-- START All Modal -->
     <!-- Start Modal consultation preliminaires -->
            <!-- The Modal -->
        <div class="modal" id="preliminaire-consul">
            <div class="modal-dialog">
                <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header">
                    <h4 class="modal-title">Informations préliminaires</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <div id="followupForm" class="ps-3">
                        <div class="mb-3">
                            <!-- <p v-if="error_msg" class="text-white alert text-center text-info">{{ error_msg }}</p> -->
                        </div>
                        <div class="mb-3">
                            <label for="tension" class="form-label fw-bold">Tension</label>
                            <input type="text" id="tension" class="form-control"  v-model = "preliminaire.tension">
                        </div>
                        <div class="mb-3">
                            <label for="poids" class="form-label fw-bold">Poids</label>
                            <input type="text" id="poids" class="form-control"  v-model = "preliminaire.poids">
                        </div>
                        <div class="mb-3">
                            <label for="taille" class="form-label fw-bold">Taille</label>
                            <input type="text" id="taille" class="form-control"  v-model = "preliminaire.taille">
                        </div>
                        <div class="mb-3">
                            <label for="sucre" class="form-label fw-bold">Taux du Sucre</label>
                            <input type="text" id="sucre" class="form-control"  v-model = "preliminaire.sucre">
                        </div>
                        <div class="mb-3">
                            <label for="temperature" class="form-label fw-bold">Température</label>
                            <input type="text" id="temperature" class="form-control"  v-model = "preliminaire.temperature">
                        </div>
                        <div class="mb-3">
                            <label for="commentaire" class="form-label fw-bold">Commentaire</label>
                            <textarea rows="3" id="commentaire" class="form-control"  v-model = "preliminaire.commentaire"></textarea>
                        </div>
                        
                    </div>
                </div>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" @click="registerPreliminaire">Save</button>
                    <button type="button" class="btn btn-danger ms-auto" data-bs-dismiss="modal">Close</button>
                </div>


                </div>
            </div>
        </div>
        <!-- END Modal consultation preliminaires -->

</template>
<script>
import $ from 'jquery';
import axios from 'axios'
const base_url=process.env.VUE_APP_API_URL;
import DashView from "@/components/DashView.vue"
export default {
    name:"AllDossierDeclasser",
    components:{
        DashView
    },
    data(){
        return{          
          dossiers:[],
          error_msg:'',
          accessToken:JSON.parse(localStorage.getItem('user_zgh')).token ?? '',
          role:JSON.parse(localStorage.getItem('user_zgh')).code_role ?? '',
          preliminaire:{
            tension:'',
            poids:'',
            taille:'',
            temperature:'',
            sucre:'',
            id_declasser:'',
            commentaire:'',
          }
        }
    },
    created(){
        // console.log($);
        // (JSON.parse(localStorage.getItem('user_zgc')).code_role)>3 ? this.$router.push('all-vente'):true;
        let url = `${base_url}/dossier_declasser`;
        if (this.role === 3) {
            url += `?docteur=true`;
        }
        axios.get(url, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: `Bearer ${this.accessToken}`
                }
            })
              .then((response)=>{
                  if(response.status==200){
                    // console.log('declasser');                    
                    //  console.log(response.data);
                      this.dossiers = response.data.filter((element)=>element.sucre !== null || element.taille !== null || element.poids !== null);
                  }                
              })
              .catch((error)=>{
                  if(error?.response?.status === 403){
                    console.log('NO access');
                    $('#openModalNoAccess').trigger('click');
                }
                else {
                // Gérer d'autres erreurs ici
                console.log('Une erreur est survenue!');
                console.log('Autre erreur:', error);
                }
                  console.error(error);
              });
    },
    methods:{
        formatDate(dateString) {
              const date = new Date(dateString);
              const day = ('0' + date.getDate()).slice(-2);
              const month = ('0' + (date.getMonth() + 1)).slice(-2);
              const year = date.getFullYear();
              const hours = ('0' + date.getHours()).slice(-2);
              const minutes = ('0' + date.getMinutes()).slice(-2);
              const seconds = ('0' + date.getSeconds()).slice(-2);
  
              return `${day}-${month}-${year}`;
        },
        registerDeclassement(){
            console.log('Form Declasser');
            this.success_msg='';
            const control = !!(this.declasserPatient.code_dossier && this.form_declasser.service && this.form_declasser.specialite);
            if(control){
                const $data = {
                    dossier: this.declasserPatient.code_dossier,
                    service : this.form_declasser.service,
                    service_name: this.services.filter(element=>element.id==this.form_declasser.service)[0].service,
                    specialite:this.form_declasser.specialite,
                    docteur: this.form_declasser.doctor
                };
                // console.log($data);

                axios.post(`${base_url}/declasser_dossier`,$data,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    console.log(response.data);
                    if(response.status==201){
                        this.success_msg = `Dossier déclassé avec success!`;
                        setTimeout(function() {
                            location.reload();
                        },2000);
                    }
                    else{
                        console.log('Erreur!!!');
                    }
                })
                .catch((error)=>{
                    // console.log(error);
                    if (error?.response?.status === 401) {
                            const error_msg = error.response.data.errors;
                            console.log(error_msg);
                            this.displayValidationErrors(error.response.data.errors);                       
                    } 
                    else if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#closeModalAddAssurance').trigger('click');
                        $('#openModalNoAccess').trigger('click');
                    }
                    else {
                    // Gérer d'autres erreurs ici
                    console.log('Autre erreur:', error);
                    }
                })
            }
        },
        redirectTo(path) {
            const consult = JSON.parse(localStorage.getItem('panier_zgh'))?.consultation??{};
            const controlConsultation = !!(Object.keys(consult).length==4);
            if(controlConsultation){
                // console.log(consult.patient);
                const url_ =`/consultation-dossier/${consult.patient}`;
                this.$router.push(url_);                
            }
            else{
                this.$router.push(path);
            }
        },
        registerPreliminaire(){
            const $data={
                declasser_id: this.preliminaire.id_declasser,
                tension: this.preliminaire.tension,
                taille : this.preliminaire.taille,
                poids: this.preliminaire.poids,
                sucre: this.preliminaire.sucre,
                temperature : this.preliminaire.temperature,
                description: this.preliminaire.commentaire
                
            }
            console.log($data);
            
            // if($data){
            //     console.log($data);
            // }

            axios.post(`${base_url}/add-info-preliminaire`,$data,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    console.log('Apres prelimi...');
                    
                    console.log(response.data);
                    if(response.status==200){
                        this.success_msg = `Données ajoutées avec success!`;
                        setTimeout(function() {
                            location.reload();
                        },2000);
                    }
                    else{
                        console.log('Erreur!!!');
                    }
                })
                .catch((error)=>{
                    // console.log(error);
                    if (error?.response?.status === 401) {
                            const error_msg = error.response.data.errors;
                            console.log(error_msg);
                            this.displayValidationErrors(error.response.data.errors);                       
                    } 
                    else if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#closeModalAddAssurance').trigger('click');
                        $('#openModalNoAccess').trigger('click');
                    }
                    else {
                     // Gérer d'autres erreurs ici
                     console.log('Autre erreur:', error);
                    }
                })            
            
        },
        getIdDeclasser(id){
            console.log(id);            
           this.preliminaire.id_declasser =  id;
        }
  },
  mounted(){
    },
}
</script>
<style scoped>


</style>